import { actionTypesEnum } from '../enum';

export const isLoading = (state = null, action) => {

    if (action.type === actionTypesEnum.loading) {
      return action.payload;
    }
  
    return state;
  };